module.exports = __webpack_public_path__ + "static/img/p-9.3189639.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-9.png
// module id = 7zxd
// module chunks = 0